import { render, staticRenderFns } from "./FancyCurrencyComponent.vue?vue&type=template&id=a7fed332&scoped=true&"
import script from "./FancyCurrencyComponent.vue?vue&type=script&lang=ts&"
export * from "./FancyCurrencyComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FancyCurrencyComponent.vue?vue&type=style&index=0&id=a7fed332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fed332",
  null
  
)

export default component.exports